import { EnvironmentUrls } from 'Roblox';

const { apiGatewayUrl } = EnvironmentUrls;

const veriffScriptUrl = 'https://cdn.veriff.me/sdk/js/1.1/veriff.min.js';
const veriffInContextScriptUrl = 'https://cdn.veriff.me/incontext/js/v1/veriff.js';
const veriffIframeDomain = 'https://magic.veriff.me/v';

const getSessionUrlConfig = () => ({
  retryable: true,
  withCredentials: false,
  url: `${apiGatewayUrl}/age-verification-service/v1/age-verification/session-url`
});

export { veriffScriptUrl, veriffInContextScriptUrl, veriffIframeDomain, getSessionUrlConfig };
